module.exports = __webpack_public_path__ + "static/media/left.f0f5cd9b.svg";